import { Column } from "@/shared/Column";
import getLocales from '../locales';

export const ipReg = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export const isIp = (path: string): boolean => ipReg.test(path);

export function mergeTableColumns(defaultColumns: any[], mergeColumns?: Column[]): any[] {
  if (!mergeColumns) return defaultColumns;

  let offset = 0;
  for (let item of mergeColumns) {
    if (item.index === -1) {
      defaultColumns.push(item);
      continue;
    } else {
      if (item.override) {
        defaultColumns[item.index + offset] = item;
      } if (item.hidden) {
        defaultColumns.splice(item.index + offset, 1);
        offset--;
      }
      else {
        defaultColumns.splice(item.index + offset, 0, item);
        offset++;
      }
    }
  }
  return defaultColumns;
}

export const getFormatMessage = (): ((data: {
  id: string;
  defaultMessage?: string;
  parameters?: any;
}) => string) => {
  const formatMessage = ({
    id,
    defaultMessage,
    parameters,
  }: {
    id: string;
    defaultMessage?: string;
    parameters?: any;
  }): string => {
    const locales = getLocales();
    if (locales[id]) {
      if (parameters) {
        let text = locales[id];
        const keys = Object.keys(parameters);
        keys.forEach(key => {
          text = text.replace(`{${key}}`, parameters[key]);
        })
        return text;
      }
      return locales[id];
    }
    if (defaultMessage) {
      return defaultMessage as string;
    }
    return id;
  };
  return formatMessage;
};

const defaultPortMap = {
  'ws://': '80',
  'wss://': '443',
}

export function formatMqttUrl(schema: string, url: string): string {
  if (['ws://', 'wss://'].includes(schema)) {
    let i = url.indexOf('/');
    if (i >= 0) {
      const host = url.substring(0, i);
      const path = url.substring(i);
      const ipPort = host.split(':');
      const port = ipPort.length <= 1 ? defaultPortMap[schema] : ipPort[1]
      return `${schema}${ipPort[0]}:${port}${path}`;
    } else {
      const ipPort = url.split(':');
      const port = ipPort.length <= 1 ? defaultPortMap[schema] : ipPort[1]
      return `${schema}${ipPort[0]}:${port}`;
    }
  }
  return `${schema}${url}`;
}

export const groupBy = (xs, f): any => {
  return xs.reduce(
    (r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r),
    {}
  )
}

export function delay(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function isAsyncFunction(f: any): boolean {
  return f && f.constructor.name === 'AsyncFunction'
}
